
function maVecVerEncuentros(response) {
  let valor = '';
  let valorCambiaPanelLateral = Number;
  const matrizActionValor = [];
  let jsonActionValor = {};
  if (response.cedula) {
    const accionStore = 'setCedulaPaciente';
    valorCambiaPanelLateral = 6;
    valor = response.cedula;
    jsonActionValor = {
      valor,
      accionStore,
    };
    matrizActionValor.push(jsonActionValor);
  }
  return ([matrizActionValor, valorCambiaPanelLateral]);
}
function maVecSeleccionarTipoEncuentro(response) {
  let valor = '';
  let valorCambiaPanelLateral = Number;
  const matrizActionValor = [];
  let jsonActionValor = {};
  if (response.cedula) {
    const accionStore = 'setCedulaPaciente';
    valorCambiaPanelLateral = 6;
    valor = response.cedula;
    jsonActionValor = {
      valor,
      accionStore,
    };
    matrizActionValor.push(jsonActionValor);
  } if (response.encuentro !== 'no') {
    const accionStore = 'setConsultarEncuentro';
    valorCambiaPanelLateral = 6;
    valor = response.encuentro;
    jsonActionValor = {
      valor,
      accionStore,
    };
    matrizActionValor.push(jsonActionValor);
  }
  return ([matrizActionValor, valorCambiaPanelLateral]);
}
function maVecSeleccionarFecha(response) {
  let valor = '';
  let valorCambiaPanelLateral = Number;
  const matrizActionValor = [];
  let jsonActionValor = {};
  if (response.id) {
    const accionStore = 'setId';
    valorCambiaPanelLateral = 6;
    valor = response.id;
    jsonActionValor = {
      valor,
      accionStore,
    };
    matrizActionValor.push(jsonActionValor);
  }
  if (response.encuentro != 'no') {
    const accionStore = 'setConsultarEncuentro';
    valorCambiaPanelLateral = 6;
    valor = response.encuentro;
    jsonActionValor = {
      valor,
      accionStore,
    };
    matrizActionValor.push(jsonActionValor);
  }
  return ([matrizActionValor, valorCambiaPanelLateral]);
}
module.exports.verEncuentrosEstados = function verEncuentrosEstados(action, response) {
  return new Promise((resolve, reject) => {
    switch (action) {
      case 'ma_vec_ver_encuentros':
        resolve(maVecVerEncuentros(response));
        break;
      case 'ma_vec_seleccionar_tipo_encuentro':
        resolve(maVecSeleccionarTipoEncuentro(response));
        break;
      case 'ma_vec_seleccionar_fecha':
        resolve(maVecSeleccionarFecha(response));
        break;
      default:
        reject('Error');
        break;
    }
  });
};



// WEBPACK FOOTER //
// ./src/js/modulosChatBox/verEncuentros.js